module.exports = __webpack_public_path__ + "static/media/contact.1c17d010.jpg";